// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps, type ComponentType } from 'react';
import { useLegacySearchTheme } from '@atlaskit/navigation-system/experimental/use-legacy-search-theme';
import { ProductSearchInputSkeleton as ProductSearchInputSkeletonDI } from '@atlassian/product-search-dialog/skeleton';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsHydrateRenderMode } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';
import { useTheme as useThemeDI } from '../../../controllers/theme/main.tsx';
import type { UseThemeType } from '../../../controllers/theme/types.tsx';

type Props = {
	useTheme?: UseThemeType;
	ProductSearchInputSkeleton?: ComponentType<
		JSX.LibraryManagedAttributes<
			typeof ProductSearchInputSkeletonDI,
			ComponentProps<typeof ProductSearchInputSkeletonDI>
		>
	>;
	placeholder?: string;
	ariaLabel?: string;
};

export const Skeleton = ({
	ProductSearchInputSkeleton = ProductSearchInputSkeletonDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useTheme = useThemeDI,
	placeholder,
	ariaLabel,
}: Props): React.JSX.Element => {
	/**
	 * The nav3 custom theme object
	 */
	// eslint-disable-next-line react-hooks/react-compiler
	useTheme();
	/**
	 * A nav4 search theme that works with the nav3 theming API
	 */
	const newTheme = useLegacySearchTheme();
	const isPageHydrating = useIsHydrateRenderMode();
	return (
		<ProductSearchInputSkeleton
			shouldFillContainer
			theme={newTheme}
			placeholder={placeholder}
			ariaLabel={ariaLabel}
			dataSsrPlaceholder={
				!isPageHydrating && fg('qs-7058-remove-experiment-call-search-dialog')
					? 'nav4-search-bar'
					: undefined
			}
		/>
	);
};
